var map = {
	"./Sem Título": 10,
	"./Sem Título.png": 10,
	"./cash-white": 11,
	"./cash-white.png": 11,
	"./checkbox-filled-in": 12,
	"./checkbox-filled-in.png": 12,
	"./custom-select": 13,
	"./custom-select.png": 13,
	"./favicon": 6,
	"./favicon.ico": 188,
	"./favicon.png": 6,
	"./glg-premium": 14,
	"./glg-premium.png": 14,
	"./golf-background": 7,
	"./golf-background.jpg": 189,
	"./golf-background.png": 7,
	"./google-logo": 15,
	"./google-logo.svg": 15,
	"./icon/danger": 16,
	"./icon/danger.svg": 16,
	"./icon/four_player_scramble": 17,
	"./icon/four_player_scramble.png": 17,
	"./icon/individual_stableford": 18,
	"./icon/individual_stableford.png": 18,
	"./icon/success": 19,
	"./icon/success.svg": 19,
	"./icon/two_player_bestball": 20,
	"./icon/two_player_bestball.png": 20,
	"./icon/warning": 21,
	"./icon/warning.svg": 21,
	"./logo-black": 22,
	"./logo-black.png": 22,
	"./logo-branding": 23,
	"./logo-branding.png": 23,
	"./logo-icon": 24,
	"./logo-icon.png": 24,
	"./logo-outings-blue": 25,
	"./logo-outings-blue.png": 25,
	"./logo-outings-text": 26,
	"./logo-outings-text.png": 26,
	"./logo-text": 27,
	"./logo-text.png": 27,
	"./logo-white": 28,
	"./logo-white.png": 28,
	"./xleague-branding": 29,
	"./xleague-branding.png": 29,
	"./xleague_logo": 30,
	"./xleague_logo.png": 30
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 187;